<template>
  <div class="index-container">
    <template v-if="type === 'c'">
      <div class="session-panel">
        <div class="session-panel-lllustration">
          <img src="@/assets/home-Illustration.png" />
        </div>
        <div class="session-panel-info">
          <div class="session-hrbp-info-wrap">
            <template v-if="isOfflineMode()">
              <strong>{{ $t('user.This Session is Offline') }}</strong>
            </template>
            <template v-else>
              <template v-if="!hasAbility('hrbp_working') || windowActive">
                <div class="session-panel-title">
                  {{ $t('user.Latest Update') }}
                </div>
                <div class="session-panel-content">
                  {{ $t('user.The Project ROAR open window is closed.') }}
                </div>
              </template>
              <template v-else>
                <div class="session-panel-title">
                  {{ $t('user.Important Date') }}
                </div>
                <div class="session-panel-date" style="margin-top: 24px">
                  <CalendarOutlined />
                  {{ $t('user.ROAR Application HRBP Review Due Date') }}:
                  {{ hrbpReviewDate[1] }}
                  <a-tooltip>
                    <template #title>
                      {{ $t('user.Please review the status of application, remind leaders for pending cases and reopen assessment if needed before the due date.System will automatically publish application status to the employee after this due date.') }}
                    </template>
                    <QuestionCircleFilled />
                  </a-tooltip>
                </div>
                <div class="session-panel-date">
                  <CalendarOutlined />
                  {{ $t('user.Panel Result Submission Due Date') }}:
                  {{ hrbpSubmitDate[1] }}
                  <a-tooltip>
                    <template #title>
                      {{ $t('user.After getting global confirmation, please upload the panel result and comments before the due date.TMOD will publish the result to all before payroll cut - off date.') }}
                    </template>
                    <QuestionCircleFilled />
                  </a-tooltip>
                </div>
              </template>
            </template>

            <div class="apply-button">
              <router-link :to="{ path: '/group/list' }">
                <a-button type="primary" class="btn-apply">
                   <span>{{ $t('user.Group List') }}</span>
                </a-button>
              </router-link>
            </div>
          </div>
          <!-- <div class="session-hrbp-info-wrap" v-else>{{ $t('user.Offline Mode Is On') }}</div> -->
        </div>
      </div>
      <div class="session-panel2">
        <div class="session-panel2-header">
          <div class="session-panel2-h2">
            {{ $t('user.Learning Resource') }}
          </div>
        </div>
        <div class="session-panel2-links">
          <div class="link-item">
            <a href="https://roar-url.publicis-groupe.cn/employeenew" target="_blank">
              <img src="@/assets/icon/employee-toolkit.png" />
              <div class="link-text">{{ $t('user.Toolkit For Employee') }}</div>
            </a>
          </div>
          <div class="link-item">
            <a href="https://roar-url.publicis-groupe.cn/managernew" target="_blank">
              <img src="@/assets/icon/employee-toolkit.png" />
              <div class="link-text">
                {{ $t('user.Toolkit For Review Manager') }}
              </div>
            </a>
          </div>
          <div class="link-item">
            <a href="https://roar-url.publicis-groupe.cn/hrbpnew" target="_blank">
              <img src="@/assets/icon/employee-toolkit.png" />
              <div class="link-text">{{ $t('user.Toolkit For HRBP') }}</div>
            </a>
          </div>

          <!-- <div class="link-item">
            <a href="https://roar-url.publicis-groupe.cn/pgca" target="_blank">
              <img src="@/assets/icon/learning-calendar.png" />
              <div class="link-text">Learning Calendar</div>
            </a>
          </div> -->
          <div class="link-item">
            <a href="https://careerconversations.publicisgroupe.net/" target="_blank">
              <img src="@/assets/icon/icon-career.svg" />
              <div class="link-text">
                Career
                <br />
                Conversations
              </div>
            </a>
          </div>

          <div class="link-item">
            <router-link :to="{ path: '/me/application/guide' }">
              <img src="@/assets/icon/career-guide.png" />
              <div class="link-text">
                {{ $t('user.Young Talent Career Guide and Learning Resources') }}
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div style="height: 28px"></div>
    </template>
    <template v-else-if="type === 'b'">
      <div class="session-panel">
        <div class="session-panel-lllustration">
          <img src="@/assets/home-Illustration.png" />
        </div>
        <div class="session-panel-info">
          <div>
            <div class="session-panel-title">
              {{ $t('user.Welcome to Project ROAR') }}
            </div>
            <div class="session-panel-content">
              {{ $t('user.Publicis Commitment') }}
            </div>
            <div class="session-panel-content">
              {{ $t('user.Platform Description') }}
            </div>
            <div class="session-panel-date" style="margin-top: 24px" v-if="isRoleA() && !hasExpired">
              <CalendarOutlined />
              <span class="session-panel-label">
                {{ $t('user.Application Start Date') }}
              </span>
              {{ applicationPeriod[0] }}
            </div>
            <div class="session-panel-date" v-if="isRoleA() && !hasExpired">
              <CalendarOutlined />
              <span class="session-panel-label">
                {{ $t('user.Application Due Date') }}
              </span>
              {{ applicationPeriod[1] }}
            </div>
            <div class="session-panel-title" v-if="isRoleA() && hasExpired">
              {{ $t('user.Latest Update') }}
            </div>
            <div class="session-panel-content" v-if="isRoleA() && hasExpired">
              {{ $t('user.The Project ROAR open window is closed.') }}
            </div>
            <div v-if="isOfflineMode()">
                <strong>{{ $t('user.This Session is Offline') }}</strong>
            </div>
            <div class="session-panel-date" v-else>
              <CalendarOutlined />
              <span class="session-panel-label">
                {{ $t('user.Application Approval Period') }}
              </span>
              {{ applicationApprovalPeriod[0] + ' - ' + applicationApprovalPeriod[1] }}
            </div>
            <ApplyButton v-if="isRoleA()" :offline="isOfflineMode()"/>
            <TeamButton></TeamButton>
          </div>
        </div>
      </div>
      <div class="session-panel2">
        <div class="session-panel2-header">
          <div class="session-panel2-h2">
            {{ $t('user.Learning Resource') }}
          </div>
        </div>
        <div class="session-panel2-links">
          <div class="link-item">
            <a href="https://roar-url.publicis-groupe.cn/employeenew" target="_blank">
              <img src="@/assets/icon/employee-toolkit.png" />
              <div class="link-text">{{ $t('user.Toolkit For Employee') }}</div>
            </a>
          </div>
          <div class="link-item">
            <a href="https://roar-url.publicis-groupe.cn/managernew" target="_blank">
              <img src="@/assets/icon/employee-toolkit.png" />
              <div class="link-text">
                {{ $t('user.Toolkit For Review Manager') }}
              </div>
            </a>
          </div>
          <div class="link-item">
            <a href="https://marcel.ai/classes/" target="_blank">
              <img src="@/assets/icon/marcel-classes.png" />
              <div class="link-text">Marcel Classes</div>
            </a>
          </div>
          <!-- <div class="link-item">
            <a href="https://roar-url.publicis-groupe.cn/pgca" target="_blank">
              <img src="@/assets/icon/learning-calendar.png" />
              <div class="link-text">Learning Calendar</div>
            </a>
          </div> -->
          <div class="link-item">
            <a href="https://careerconversations.publicisgroupe.net/" target="_blank">
              <img src="@/assets/icon/icon-career.svg" />
              <div class="link-text">
                Career
                <br />
                Conversations
              </div>
            </a>
          </div>

          <div class="link-item">
            <router-link :to="{ path: '/me/application/guide' }">
              <img src="@/assets/icon/career-guide.png" />
              <div class="link-text">
                {{ $t('user.Young Talent Career Guide and Learning Resources') }}
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div style="height: 28px"></div>
    </template>
    <template v-else>
      <div class="session-panel">
        <div class="session-panel-lllustration">
          <img src="@/assets/home-Illustration.png" />
        </div>
        <div class="session-panel-info">
          <div>
            <div class="session-panel-title">
              {{ $t('user.Welcome to Project ROAR') }}
            </div>
            <div class="session-panel-content">
              {{ $t('user.Publicis Commitment') }}
            </div>
            <div class="session-panel-content">
              {{ $t('user.Platform Description') }}
            </div>

            <div>
              <div class="session-panel-content"  v-if="isOfflineMode()">
                  <strong>{{ $t('user.This Session is Offline') }}</strong>
              </div>
              <template v-else>
                <div class="session-panel-date" style="margin-top: 24px" v-if="!hasExpired && isRoleA()">
                    <CalendarOutlined />
                    <strong>{{ $t('user.Application Start Date') }}:</strong>
                    {{ applicationPeriod[0] }}
                </div>
                <div class="session-panel-date" v-if="!hasExpired && isRoleA()">
                    <CalendarOutlined />
                    <strong>{{ $t('user.Application Due Date') }}:</strong>
                    {{ applicationPeriod[1] }}
                </div>
                <div class="session-panel-title" v-if="isRoleA() && hasExpired">
                    {{ $t('user.Latest Update') }}
                </div>
                <div class="session-panel-content" v-if="isRoleA() && hasExpired">
                    {{ $t('user.The Project ROAR open window is closed.') }}
                </div>
              </template>

              <ApplyButton :offline="isOfflineMode()" />
            </div>
          </div>
        </div>
      </div>
      <div class="session-panel2">
        <div class="session-panel2-header">
          <div class="session-panel2-h2">
            {{ $t('user.Learning Resource') }}
          </div>
        </div>
        <div class="session-panel2-links">
          <div class="link-item">
            <a href="https://roar-url.publicis-groupe.cn/employeenew" target="_blank">
              <img src="@/assets/icon/employee-toolkit.png" />
              <div class="link-text">{{ $t('user.Toolkit For Employee') }}</div>
            </a>
          </div>
          <div class="link-item">
            <a href="https://marcel.ai/classes/" target="_blank">
              <img src="@/assets/icon/marcel-classes.png" />
              <div class="link-text">Marcel Classes</div>
            </a>
          </div>
          <!-- <div class="link-item">
            <a href="https://roar-url.publicis-groupe.cn/pgca" target="_blank">
              <img src="@/assets/icon/learning-calendar.png" />
              <div class="link-text">Learning Calendar</div>
            </a>
          </div> -->
          <div class="link-item">
            <a href="https://careerconversations.publicisgroupe.net/" target="_blank">
              <img src="@/assets/icon/icon-career.svg" />
              <div class="link-text">
                Career
                <br />
                Conversations
              </div>
            </a>
          </div>

          <div class="link-item">
            <router-link :to="{ path: '/me/application/guide' }">
              <img src="@/assets/icon/career-guide.png" />
              <div class="link-text">
                {{ $t('user.Young Talent Career Guide and Learning Resources') }}
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div style="height: 28px"></div>
    </template>
  </div>
</template>

<script>
  import { CalendarOutlined, QuestionCircleFilled } from '@ant-design/icons-vue'
  import { mapGetters } from 'vuex'
  import ApplyButton from './components/ApplyButton.vue'
  import TeamButton from './components/TeamButton.vue'

  export default {
    name: 'Index',
    components: {
      ApplyButton,
      TeamButton,
      CalendarOutlined,
      QuestionCircleFilled,
    },
    data() {
      return {
        type: null,
      }
    },
    computed: {
      ...mapGetters({
        role: 'acl/role',
        ability: 'acl/ability',
        applicationPeriod: 'user/applicationPeriod',
        applicationApprovalPeriod: 'user/applicationApprovalPeriod',
        hrbpReviewDate: 'user/hrbpReviewDate',
        hrbpSubmitDate: 'user/hrbpSubmitDate',
        offlineMode: 'user/offlineMode',
      }),
      hasExpired() {
        return !this.hasAbility('apply')
      },
      windowActive() {
        return !this.hasAbility('window_active')
      },
    },
    created() {
      if (this.role.indexOf('d') >= 0) {
        this.$router.replace('/master')
      }
    },
    mounted() {
      this.type = this.getResourceByRole()
    },
    methods: {
      hasAbility(key) {
        const ability = this.ability.find((item) => item.key === key)
        if (ability == null) {
          console.log('getAbility', ability)
        }
        return ability != null && ability.value
      },
      isRoleA() {
        return this.role.indexOf('a') >= 0
      },
      isOfflineMode() {
        return this.offlineMode
      },
      isRoleC() {
        return this.role.indexOf('c') >= 0
      },
      // hasExpired() {
      //   const currentDate = new Date().getTime()
      //   if (this.hrbpSubmitDate.length > 0) {
      //     const endDate = new Date(this.hrbpSubmitDate[1]).getTime()
      //     return endDate - currentDate < 0
      //   } else {
      //     return false
      //   }
      // },
      getResourceByRole() {
        if (this.role.length > 1 && this.role.indexOf('b') > 0) {
          return 'b'
        } else {
          return this.role[0]
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  @import url('@/styles/params.less');

  .index-container {
    margin: @app-conetent-margin;
  }

  .session-panel {
    display: flex;
    background-color: white;
    padding: 16px;
    margin-bottom: 16px;
    text-align: center;

    &-lllustration {
      flex-grow: 1;
      width: 50%;
      max-height: 420px;
      margin-right: 25px;
      display: flex;

      img {
        object-fit: contain;
        width: 100%;
      }
    }

    &-info {
      flex-grow: 1;
      width: 50%;
      text-align: left;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title {
      font-size: 26px;
      font-weight: bold;
      color: #333333;
      line-height: 32px;
    }

    &-content {
      width: 100%;
      font-size: 14px;
      color: #333333;
      line-height: 22px;
      margin-top: 8px;
      margin-bottom: 12px;
      padding-right: 12px;
    }

    &-date {
      margin-bottom: 5px;
      font-size: 14px;
      color: #333333;
      line-height: 22px;
      font-weight: 700;
    }
  }

  .session-panel2 {
    background-color: white;

    &-header {
      width: 100%;
      border-bottom: 1px solid #e9e9e9;
      border-radius: 2px 2px 0px 0px;
      padding: 20px 24px;
    }

    &-h2 {
      font-size: 20px;
      // font-family: Helvetica-Bold, Helvetica;
      font-weight: bold;
      color: #333333;
      line-height: 32px;
    }

    &-links {
      display: flex;
      justify-content: center;
      padding: 32px 24px;

      .link-item {
        width: 272px;
        flex-grow: 1;
        min-height: 140px;
        background: #ffffff;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.15);
        padding: 14px 16px;
        margin-right: 21px;
        text-align: center;

        a {
          width: 100%;
          height: 100%;
          display: block;
        }

        .link-text {
          max-width: 186px;
          font-size: 18px;
          color: #333333;
          line-height: 30px;
          margin: 0 auto;
          text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.15);
        }

        img {
          width: 62px;
          height: 62px;
          margin-top: 18px;
          margin-bottom: 5px;
        }
      }
    }
  }

  //  HRBP
  // .session-hrbp-info {
  //   flex-grow: 1;
  //   width: 566px;
  //   min-width: 45%;
  //   padding-top: 60px;
  //   text-align: center;
  //   &-wrap {
  //     text-align: left;
  //     margin: 0 auto;
  //     max-width: 400px;
  //     padding-top: 68px;
  //   }
  // }
  .session-panel-date {
    word-break: break-word;

    .anticon {
      margin-right: 4px;
    }

    .session-panel-label {
      font-weight: 700;

      &::after {
        content: ':';
        margin: 0 8px 0 2px;
        position: relative;
        top: -0.5px;
      }
    }
  }
</style>
